export const reorderAnswers = (answers) => {
  const reordered = new Array(answers.length);
  const half = Math.ceil(answers.length / 2);
  
  for (let i = 0; i < answers.length; i++) {
    if (i < half) {
      // Left column: 1, 2, 3, 4, 5 (indices 0, 1, 2, 3, 4)
      // These should go to even positions in a 2-column grid-flow-row: 0, 2, 4, 6, 8
      reordered[i * 2] = { ...answers[i], originalIdx: i };
    } else {
      // Right column: 6, 7, 8, 9, 10 (indices 5, 6, 7, 8, 9)
      // These should go to odd positions: 1, 3, 5, 7, 9
      reordered[(i - half) * 2 + 1] = { ...answers[i], originalIdx: i };
    }
  }
  return reordered.filter(Boolean);
};
